export type {
  CertificateAlign,
  CertificateDesignerStore,
  CertificateElement,
  CertificateOrientation,
  CertificatePageSettings,
  CertificatePaperSize,
  CertificateTemplate,
  ReportTable,
} from "../certificatePrint/certificateTypes";

export {
  getPageSize,
  getCssAtPageSize,
  getJsPdfPageOptions,
  A2_PORTRAIT,
  A2_LANDSCAPE,
  A3_PORTRAIT,
  A3_LANDSCAPE,
  A4_PORTRAIT,
  A4_LANDSCAPE,
  A5_PORTRAIT,
  A5_LANDSCAPE,
  HALF_LETTER_PORTRAIT,
  HALF_LETTER_LANDSCAPE,
} from "../certificatePrint/certificateTypes";

export type InvoicePrintDefault = "bill" | "newBillPrint" | "printTemplate_2";

export const PAPER_SIZE_OPTIONS = [
  { value: "A2" as const, label: "A2", hint: "420 × 594 mm" },
  { value: "A3" as const, label: "A3", hint: "297 × 420 mm" },
  { value: "A4" as const, label: "A4", hint: "210 × 297 mm" },
  { value: "A5" as const, label: "A5", hint: "148 × 210 mm" },
  { value: "halfLetter" as const, label: "Half Letter", hint: "5.5 × 8.5 in (140 × 216 mm)" },
];
